
<nz-list class="list" [style.height.px]="listHeight" [style.width.px]="listWidth" [nzItemLayout]="'vertical'">
    <div *ngIf="cardSkeleton" nzSize="small" nzAlign="center">
        <nz-list-item [ngStyle]="{'height': itemHeight, 'padding': '5px'}" *ngFor="let _ of datasource">
                <nz-skeleton [nzActive]="true" [ngStyle]="{'width': '255px' }" [nzTitle]="false"></nz-skeleton>
        </nz-list-item>
    </div>
    <div *ngIf="projectListSkeleton" nzSize="small" nzAlign="center">
        <nz-list-item [ngStyle]="{'height': itemHeight, 'padding': '12px, 0'}" *ngFor="let _ of datasource">
            <nz-space nzSize="large" nzAlign="center">
                <nz-skeleton-element nzSize="middle" nzType="avatar" [nzActive]="true" [nzShape]="'square'" class="pr-5"></nz-skeleton-element>
                <nz-skeleton [ngStyle]="{'width': listWidth }" [nzParagraph]="{ rows: 1 }" [nzTitle]="false"></nz-skeleton>
            </nz-space>
        </nz-list-item>
    </div>
</nz-list>
